export type PackageIcon = 'car' | 'droplets' | 'sparkles' | 'shield';

export interface DetailPackage {
  slug: string;
  name: string;
  /** Dedicated page for this package. */
  path: string;
  icon: PackageIcon;
  accent: 'blue' | 'green';
  summary: string;
  features: string[];
  priceSm: string;
  priceSuv: string;
  popular?: boolean;
  /** Booking requirement shown in place of the summary on pricing cards. */
  requirement?: string;
}

export const PRICE_TIER_SM = 'SM / MID';
export const PRICE_TIER_SUV = 'SUV / CROSS';

export const packages: DetailPackage[] = [{
  slug: 'basic-wash',
  name: 'Basic Wash',
  path: '/basic-wash',
  icon: 'car',
  accent: 'green',
  summary: 'A maintenance wash that covers the essentials — exterior wash, light wipe-down, vacuum, rims, tires, and windows.',
  features: ['Exterior Wash', 'Light Wipe Down', 'Vacuum', 'Clean Rims', 'Dress Tires', 'Clean Windows'],
  priceSm: '$90',
  priceSuv: '$105',
  requirement: '2 Car Minimum · Basic Washes Only'
}, {
  slug: 'wash-wax',
  name: 'Wash & Wax',
  path: '/wash-wax',
  icon: 'droplets',
  accent: 'blue',
  summary: 'A Wash and Wax cleans your car, adds a protective layer, helps paint stay shiny, repel water, and dirt.',
  features: ['Exterior Wash', 'Window Cleaning', 'Vacuum', 'Light Wipedown Interior', 'Tire Dressing', 'Hybrid Ceramic Spray'],
  priceSm: '$160',
  priceSuv: '$180'
}, {
  slug: 'full-detail',
  name: 'Full Detail',
  path: '/full-detail',
  icon: 'sparkles',
  accent: 'green',
  summary: 'Our most popular mobile car detailing package — complete interior and exterior restoration for a showroom finish',
  features: ['Includes Interior Detail', 'Exterior Wash', 'Clay Bar Treatment', 'Clean Rims', 'Dress Tires', 'Hybrid Ceramic Spray', 'Deep Vacuum'],
  priceSm: '$300',
  priceSuv: '$350',
  popular: true
}, {
  slug: 'interior-detail',
  name: 'Interior Detail',
  path: '/services/interior-detailing',
  icon: 'shield',
  accent: 'blue',
  summary: 'Professional interior car cleaning service — deep clean, shampoo, steam sanitize every surface inside your vehicle',
  features: ['Shampoo Seats', 'Deep Clean Interior', 'Vacuum', 'Shampoo Floor Mats', 'Steam & Sanitize'],
  priceSm: '$180',
  priceSuv: '$195'
}];

export const extras = [{
  name: 'Engine Bay Top',
  price: '$120'
}, {
  name: 'Headlight Restore',
  price: '$80'
}, {
  name: 'Clay Bar Treatment',
  price: '$60'
}, {
  name: 'Water Spots / Dog Hair',
  price: 'Call for Pricing'
}, {
  name: 'Hybrid Ceramic Glass Treatment',
  price: '$200'
}, {
  name: 'Hybrid Ceramic Treatment — 1 Year',
  price: 'Call for Pricing'
}];
